import { Epic } from "redux-observable";
import { of } from "rxjs";
import { catchError, filter, mergeMap } from "rxjs/operators";
import { isActionOf } from "typesafe-actions";
import { RootState } from "../../rootReducer";
import { RootAction } from "../../types";
import { Dependencies } from "./../../../services/index";
import { Token, UserResponse } from "./../../models/users";
import { createUserAsync, fetchSelfAsync, loginAsync } from "./actions";

export const loginEpic: Epic<
  RootAction,
  RootAction,
  RootState,
  Dependencies
> = (action$, _, { login }) =>
  action$.pipe(
    filter(isActionOf(loginAsync.request)),
    mergeMap(({ payload: { email, password, token } }) => {
      return login(email, password, token).pipe(
        mergeMap((token: Token) => of(loginAsync.success(token))),
        catchError((error) => of(loginAsync.failure(error)))
      );
    })
  );

export const fetchSelfEpic: Epic<
  RootAction,
  RootAction,
  RootState,
  Dependencies
> = (action$, _, { fetchSelf }) =>
  action$.pipe(
    filter(isActionOf(fetchSelfAsync.request)),
    mergeMap(() => {
      return fetchSelf().pipe(
        mergeMap((user: UserResponse) => of(fetchSelfAsync.success(user))),
        catchError((error) => of(fetchSelfAsync.failure(error)))
      );
    })
  );

export const createUserEpic: Epic<
  RootAction,
  RootAction,
  RootState,
  Dependencies
> = (action$, _, { createUser }) =>
  action$.pipe(
    filter(isActionOf(createUserAsync.request)),
    mergeMap(({ payload: { email, password, firstName, lastName, token } }) => {
      return createUser(email, password, firstName, lastName, token).pipe(
        mergeMap((token: Token) => of(createUserAsync.success(token))),
        catchError((error) => of(createUserAsync.failure(error)))
      );
    })
  );
